module.exports = __webpack_public_path__ + "app/components/messages/create-graphic.view.html";